import React from 'react';
import PropTypes from 'prop-types';
import SecurityLock from 'components/Icons/SecurityLock';

import { useConfig } from 'config/ConfigContext';
import comodo from 'assets/images/comodo.png';
import './style.scss';

const Heading = ({ heading, subHeading, isCardVisible, size, className }) => {
  const { envLabel } = useConfig();
  return (
    // Heading
    <div className={`cell small-12 form-headline ${className}`}>
      <div className="titleWrapper">
        <h2 className={`heading ${className}`}>{heading}</h2>
        { envLabel && envLabel !== 'production' && <div className="envLabel">{ envLabel }</div> }
      </div>
      <p className={size}>{subHeading}</p>
      {
        isCardVisible && (
          <div className="grid-x security hide-for-large">
            <div className="cell small-9 ssl encryption">
              <SecurityLock width="28" className="securityLock" />
              <p className="p-small noBottomMargin">
                <strong>128-bit SSL</strong>
                {' '}
                protection and strict encryption
              </p>
            </div>
            <div className="cell small-3 certificate">
              <img src={comodo} alt="" className="sectigo-image" />
            </div>
          </div>
        )
      }
    </div>
    // End Heading
  );
};

Heading.propTypes = {
  heading: PropTypes.any,
  subHeading: PropTypes.any,
  isCardVisible: PropTypes.bool,
  size: PropTypes.any,
  className: PropTypes.string,
};

Heading.defaultProps = {
  heading: '',
  subHeading: '',
  isCardVisible: false,
  size: 'p-large',
  className: '',
};

export default Heading;
